import * as React from 'react';

import BasePaycodeListLayout from './BasePaycodeListLayout';

export default (params) => {
  return BasePaycodeListLayout();
};
